<template>
    <EmployeeTable></EmployeeTable>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const EmployeeTable = defineAsyncComponent(() =>
    import("../../components/DPAM_PunchSystem/Employees/Table.vue")
);

export default {
    name: "DPAM_PUNCH_EMPLOYEES", //The name you are in should not equal the name of the component you are importing.
    components: { EmployeeTable, AuthLayout },
};
</script>
